import { z } from 'zod';
/** Puntos de carga por prioridad cuando la política no dice otra cosa. */
export const WORKLOAD_POINTS_DEFAULT = { LOW: 1, NORMAL: 2, HIGH: 4, CRITICAL: 6 };
/** Configurable scoring weights. Stored per tenant in assignment_policies. */
export const assignmentPolicySchema = z.object({
    weights: z
        .object({
        /** Tener la especialidad del caso (la exacta cuenta completo; una superior, la mitad). */
        specialty: z.number().min(0).default(30),
        availableCapacity: z.number().min(0).default(35),
        relativeLoad: z.number().min(0).default(20),
        recentAssignmentPenalty: z.number().min(0).default(5),
    })
        .default({}),
    /** Puntos de carga de un caso según su prioridad: la capacidad de cada persona se mide en estos puntos. */
    workloadPoints: z
        .object({
        LOW: z.number().default(WORKLOAD_POINTS_DEFAULT.LOW),
        NORMAL: z.number().default(WORKLOAD_POINTS_DEFAULT.NORMAL),
        HIGH: z.number().default(WORKLOAD_POINTS_DEFAULT.HIGH),
        CRITICAL: z.number().default(WORKLOAD_POINTS_DEFAULT.CRITICAL),
    })
        .default({}),
    /** Hard rule: never exceed capacity. */
    allowOverCapacity: z.boolean().default(false),
    /** Tie breaker. */
    tieBreaker: z.enum(['LEAST_LOAD', 'ROUND_ROBIN', 'RANDOM']).default('LEAST_LOAD'),
});
export const ReassignReason = {
    VACATION: 'VACATION',
    ABSENCE: 'ABSENCE',
    OVERLOAD: 'OVERLOAD',
    WRONG_SPECIALTY: 'WRONG_SPECIALTY',
    CONFLICT: 'CONFLICT',
    ESCALATION: 'ESCALATION',
    OTHER: 'OTHER',
};
export const reassignSchema = z.object({
    toUserId: z.string().uuid(),
    reasonCode: z.enum(['VACATION', 'ABSENCE', 'OVERLOAD', 'WRONG_SPECIALTY', 'CONFLICT', 'ESCALATION', 'OTHER']),
    comment: z.string().max(2000).optional(),
});
//# sourceMappingURL=assignment.js.map